export class EditableLabelEvent extends CustomEvent {
    constructor(opts) {
        super('changed', {
            detail: opts.label,
        });
        this.label = opts.label;
        this.id = opts.id;
    }
    getLabel() {
        return this.label;
    }
    getId() {
        return this.id;
    }
}
